// form-availability-errors.data.ts
//
// A flow is closed or paused for this practice.

import { ErrorEntry } from './error-metadata.types';

export const formAvailabilityErrors = {
  'patient-portal-form-closed': {
    message:
      'Online requests are currently unavailable. If you entered any information, it was not sent to your practice.\n' +
      'Please come back when requests are open.\n',
    title: 'Online requests are now closed',
    components: [
      {
        name: 'mpf-tenant-info',
        props: {
          showOpeningTimes: true,
          showEmergencyCallSurgery: true,
          showOutOfHours111: true,
          showEmergency999: true,
        },
      },
    ],
  },
  'medical-request-form-unavailable': {
    message:
      'Online medical requests are currently unavailable. If you entered any information, it was not sent to your practice.\n' +
      'Please come back when requests are open.\n\n',
    title: 'Temporarily Unavailable',
    requestType: 'medical',
    components: [
      {
        name: 'mpf-tenant-info',
        props: {
          showOpeningTimes: true,
          showEmergencyCallSurgery: true,
        },
      },
    ],
  },
  'admin-request-form-unavailable': {
    message:
      'Online admin requests are currently unavailable. If you entered any information, it was not sent to your practice.\n' +
      'Please come back when requests are open.\n\n',
    title: 'Temporarily Unavailable',
    requestType: 'admin',
    components: [
      {
        name: 'mpf-tenant-info',
        props: {
          showOpeningTimes: true,
          showEmergencyCallSurgery: true,
        },
      },
    ],
  },
  'repeat-medication-request-form-unavailable': {
    message:
      'Online repeat prescription requests are temporarily suspended. If you entered any information, it was not sent to your practice.',
    title: 'Temporarily Unavailable',
    requestType: 'repeat-prescription',
    components: [
      {
        name: 'mpf-tenant-info',
        props: {
          showEmergencyCallSurgery: true,
        },
      },
    ],
  },
} satisfies Record<string, ErrorEntry>;
